import { generateRoomIds } from "@/shared/libs/utils";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";
import type { HotelDetailV2BookingModel } from "../model/hotelDetailV2.model";

export function createHotelPassengersUrl({
  city,
  slug,
  booking,
  selectedRooms,
  currentQuery,
}: {
  city: string;
  slug: string;
  booking: HotelDetailV2BookingModel;
  selectedRooms: MinPriceRoom[];
  currentQuery: string;
}) {
  const params = new URLSearchParams(currentQuery);
  params.delete("passengerKey");
  params.set("checkIn", booking.checkIn);
  params.set("checkOut", booking.checkOut);
  params.set("rooms", booking.roomsParam);
  params.set("room_id", generateRoomIds(selectedRooms));
  params.set("hotel", slug);
  params.set("accommodationKey", booking.accommodationKey || "");

  return `/hotel/${city}/passengers/?${params.toString()}`;
}

export function getSelectedRoomsCount(rooms: MinPriceRoom[]) {
  return rooms.reduce((total, room) => total + room.count, 0);
}

export function getSelectedRoomsTotal(rooms: MinPriceRoom[]) {
  return rooms.reduce(
    (total, room) => total + room.rate_plans.price * room.count,
    0,
  );
}
